var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 565.1 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #010101;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: #1c5faa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 4.1,
    y: 4.5,
    width: 203.3,
    height: 78.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.9,11.7l-4.4,13.6c-3.5-1.7-8.4-3.1-15.2-3.1s-13.2,1.1-13.2,6.6c0,9.7,26.7,6.1,26.7,26.9s-17.6,23.8-33.6,23.8-15.3-1.7-21.3-3.5l4.3-13.9c3.6,2.4,10.9,3.9,16.9,3.9s14.7-1.1,14.7-8.1c0-11-26.7-6.9-26.7-26.2s15.6-23,30.7-23,16.5.9,21.1,3M152,9.8l-14.3,68.4h-18.4l6.1-29.3h-21.8l-6.1,29.3h-18.4l14.3-68.4h18.4l-5.4,26.2h21.8l5.4-26.2h18.4ZM86.5,9.8l-14.6,68.4h-22.9l-14.4-47.4h-.2l-9.6,47.4H7.6L22.3,9.8h23l14.1,47.5h.2l9.7-47.5h17.3ZM212.8,1.6H1.6v85h211.2V1.6Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,112.2h8.4v26.9c0,10.3-5.6,15.7-17.1,15.7s-17.1-5.8-17.1-15.7v-26.9h8.4v24.4c0,7.5,2.7,11.6,8.7,11.6s8.7-4.1,8.7-11.6v-24.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.4,154.1v-17.3c0-4.6-1-8-5.2-8s-7.1,4.9-7.1,10.4v15h-8v-30.9h7.6v4.2h.1c2.5-3.5,5.9-4.9,10.1-4.9,7.1,0,10.5,4.9,10.5,12.1v19.5h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.9,117.6v-7.7h8v7.7h-8ZM85.9,154.1v-30.9h8v30.9h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.5,154.1l-11.5-30.9h8.6l7.7,22.5h.1l7.4-22.5h8l-11.4,30.9h-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.6,152.4c-2.9,1.6-6.3,2.5-10.6,2.5-10.3,0-16.2-5.9-16.2-16s4.5-16.3,14.3-16.3,14.7,6.5,14.7,18.7h-21.4c.4,4.9,3.7,7.8,8.9,7.8s7.2-1.4,10.2-3.1v6.5ZM155.2,135.6c-.3-4.4-2.4-7.3-6.6-7.3s-6.7,2.6-7.1,7.3h13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.3,154.1v-30.9h7.1v7h.1c.5-3.2,3.8-7.7,8.5-7.7s2.2.2,2.4.2v8.1c-.7-.4-2.2-.7-3.6-.7-3,0-6.5,1.6-6.5,11.2v12.7h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.3,146.9c2.5,1.3,5.2,2,7.9,2s5.3-.8,5.3-3.8-2.5-3.4-5.8-4.3c-5.4-1.4-8.2-3.7-8.2-8.8s5.2-9.6,12.2-9.6,4.9.2,8.7,1.1l-.5,6.1c-2.8-1-4.6-1.3-7.1-1.3s-4.8,1.1-4.8,3.4,1.7,2.6,5.3,3.6c5.8,1.6,8.6,4.2,8.6,9.4s-5.8,10.1-13,10.1-6.1-.5-9.1-1.3l.5-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.3,117.6v-7.7h8v7.7h-8ZM219.3,154.1v-30.9h8v30.9h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.2,154.1c-1.7.5-3.5.7-5.9.7-6.5,0-9.8-4.1-9.8-10v-15.7h-5.9v-5.9h5.9v-6.2l8-2.6v8.8h7.1v5.9h-7.1v14.3c0,3.2,1,5.2,3.8,5.2s2.8-.3,3.6-.8l.2,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.1,160.7c1.2.4,2.5.5,4.1.5,3.4,0,5.3-2.3,5.3-5.5l-11.8-32.5h8.9l7.4,22.6h.1l7.4-22.6h8.2l-13,34.3c-2.3,6.1-5,9.9-11.6,9.9s-3.7-.3-5.6-.8l.5-5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.1,154.1v-18.4h-16.8v18.4h-8.4v-41.9h8.4v16.9h16.8v-16.9h8.4v41.9h-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.7,154.8c-10,0-16.1-6.8-16.1-16s6.7-16.4,16.1-16.4,16.2,6.4,16.2,16.4-6.2,16-16.2,16ZM374.5,137.9c0-4.9-2.6-9.2-7.8-9.2s-7.7,4.3-7.7,9.2,2.5,10.7,7.7,10.7,7.8-4,7.8-10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388,146.9c2.5,1.3,5.2,2,7.9,2s5.3-.8,5.3-3.8-2.5-3.4-5.8-4.3c-5.4-1.4-8.2-3.7-8.2-8.8s5.2-9.6,12.2-9.6,4.9.2,8.7,1.1l-.5,6.1c-2.8-1-4.6-1.3-7.1-1.3s-4.8,1.1-4.8,3.4,1.7,2.6,5.3,3.6c5.8,1.6,8.6,4.2,8.6,9.4s-5.8,10.1-13,10.1-6.1-.5-9.1-1.3l.5-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M415.8,166.7v-43.5h7.7v4.4h.1c2-3.4,5.3-5.1,9.6-5.1,9,0,13,6.9,13,16.1s-3.9,16.3-13.1,16.3-6.6-1.3-9.1-4.3h-.1v16.1h-8ZM437.8,138.6c0-4.3-1.5-9.8-6.7-9.8s-7.2,5.6-7.2,9.8,1.9,10,7.1,10,6.8-5.6,6.8-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.6,117.6v-7.7h8v7.7h-8ZM452.6,154.1v-30.9h8v30.9h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.5,154.1c-1.7.5-3.5.7-5.9.7-6.5,0-9.8-4.1-9.8-10v-15.7h-5.9v-5.9h5.9v-6.2l8-2.6v8.8h7.1v5.9h-7.1v14.3c0,3.2,1,5.2,3.8,5.2s2.8-.3,3.6-.8l.2,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M511.3,154.1c-.2-1.1-.3-3.2-.4-4.6h-.1c-1.8,3.3-5.7,5.3-9.5,5.3-5.6,0-10.8-3.4-10.8-9.2s3.1-10.6,15.1-10.6h5c0-5.3-2.6-6.7-7-6.7s-6.8,1.3-9.5,3.4l-.2-6.9c2.9-1.3,7-2.3,10.7-2.3,9.2,0,13.3,3.7,13.3,13v6.4c0,1.6.1,8.1.5,12.2h-7.1ZM510.6,139.8h-3.5c-5.7,0-8.9,1.7-8.9,5.3s1.9,3.8,5.1,3.8,7.3-2.5,7.3-8.8v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M526,154.1v-45h8v45h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M541.3,146.9c2.5,1.3,5.2,2,7.9,2s5.3-.8,5.3-3.8-2.5-3.4-5.8-4.3c-5.4-1.4-8.2-3.7-8.2-8.8s5.2-9.6,12.2-9.6,4.9.2,8.7,1.1l-.5,6.1c-2.8-1-4.6-1.3-7.1-1.3s-4.8,1.1-4.8,3.4,1.7,2.6,5.3,3.6c5.8,1.6,8.6,4.2,8.6,9.4s-5.8,10.1-13,10.1-6.1-.5-9.1-1.3l.5-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.9,215.8c-10,0-16.1-6.8-16.1-16s6.7-16.4,16.1-16.4,16.2,6.4,16.2,16.4-6.2,16-16.2,16ZM27.7,198.9c0-4.9-2.6-9.2-7.8-9.2s-7.7,4.3-7.7,9.2,2.5,10.7,7.7,10.7,7.8-4,7.8-10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.4,215.1v-25h-5.9v-5.9h5.9v-4.4c0-5.2,2.7-10.4,10-10.4s4.2.3,5.8.7l-.7,6.7c-1.3-.8-2.2-1.1-3.5-1.1-2.3,0-3.5,1.8-3.5,4.7v3.8h7v5.9h-7v25h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.2,215.1v-41.9h8.4v35.3h16.3v6.6h-24.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.6,178.6v-7.7h8v7.7h-8ZM112.6,215.1v-30.9h8v30.9h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.2,215.1l-11.5-30.9h8.6l7.7,22.5h.1l7.4-22.5h8l-11.4,30.9h-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.3,213.4c-2.9,1.6-6.3,2.5-10.6,2.5-10.3,0-16.2-5.9-16.2-16s4.5-16.3,14.3-16.3,14.7,6.5,14.7,18.7h-21.4c.4,4.9,3.7,7.8,8.9,7.8s7.2-1.4,10.2-3.1v6.5ZM181.9,196.6c-.3-4.4-2.4-7.3-6.6-7.3s-6.7,2.6-7.1,7.3h13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196,215.1v-30.9h7.1v7h.1c.5-3.2,3.8-7.7,8.5-7.7s2.2.2,2.4.2v8.1c-.7-.4-2.2-.7-3.6-.7-3,0-6.5,1.6-6.5,11.2v12.7h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.2,227.7v-43.5h7.7v4.4h.1c2-3.4,5.3-5.1,9.6-5.1,9,0,13,6.9,13,16.1s-3.9,16.3-13.1,16.3-6.6-1.3-9.1-4.3h-.1v16.1h-8ZM241.1,199.6c0-4.3-1.5-9.8-6.7-9.8s-7.2,5.6-7.2,9.8,1.9,10,7.1,10,6.8-5.6,6.8-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270,215.8c-10,0-16.1-6.8-16.1-16s6.7-16.4,16.1-16.4,16.2,6.4,16.2,16.4-6.2,16-16.2,16ZM277.8,198.9c0-4.9-2.6-9.2-7.8-9.2s-7.7,4.3-7.7,9.2,2.5,10.7,7.7,10.7,7.8-4,7.8-10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.7,215.8c-10,0-16.1-6.8-16.1-16s6.7-16.4,16.1-16.4,16.2,6.4,16.2,16.4-6.2,16-16.2,16ZM314.5,198.9c0-4.9-2.6-9.2-7.8-9.2s-7.7,4.3-7.7,9.2,2.5,10.7,7.7,10.7,7.8-4,7.8-10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.3,215.1v-45h8v45h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.5,253.5h-5.9v-4.4h11.3v15c-3,.8-6,1.4-9,1.4-9.5,0-15.3-5-15.3-14s5.6-14.9,15.4-14.9,5.8.4,8.2,1.2l-.4,4.7c-2.2-1-4.9-1.5-7.2-1.5-6.2,0-10.1,4.1-10.1,10.1s3.7,10,9.5,10,2.7-.2,3.6-.4v-7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.4,265.1v-20.6h4.8v4.7h0c.3-2.2,2.6-5.2,5.7-5.2s1.4.1,1.6.2v5.4c-.5-.3-1.4-.4-2.4-.4-2,0-4.4,1.1-4.4,7.5v8.5h-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.5,265.6c-6.6,0-10.8-4.6-10.8-10.6s4.5-10.9,10.8-10.9,10.8,4.3,10.8,10.9-4.2,10.6-10.8,10.6ZM62.7,254.3c0-3.3-1.8-6.1-5.2-6.1s-5.2,2.9-5.2,6.1,1.7,7.1,5.2,7.1,5.2-2.7,5.2-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.4,265.1v-2.8h0c-1.8,2.1-4.1,3.3-6.8,3.3-4.6,0-7-3.1-7-8.1v-13h5.4v11.8c0,4.1,1.5,5.2,3.5,5.2,3.2,0,4.7-3,4.7-7v-10h5.4v20.6h-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97,273.5v-29h5.1v2.9h0c1.4-2.2,3.5-3.4,6.4-3.4,6,0,8.6,4.6,8.6,10.7s-2.6,10.8-8.8,10.8-4.4-.9-6-2.8h0v10.8h-5.4ZM111.6,254.8c0-2.8-1-6.6-4.4-6.6s-4.8,3.7-4.8,6.6,1.2,6.7,4.7,6.7,4.5-3.8,4.5-6.7Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company_logo.1e450623615c5e3b901d63bcb139a0b3.svg";
export { ForwardRef as ReactComponent };